import React, { useState, useEffect } from "react";
import styled from "styled-components/macro";
import Helmet from "react-helmet";
import { Card as MuiCard, Grid } from "@material-ui/core";
import {
  ProfileWrapper,
  PersonalInfoWrapper,
  PerformanceTabWrapper,
  ProfileTabWrapper,
} from "./Profile.styled";
import { FaEdit } from "react-icons/fa";
import { spacing } from "@material-ui/system";
import { connect } from "react-redux";
import { Button as AntButton, Modal, Result, Empty } from "antd";
import roleRedirect from "../../components/RoleRedirect/RoleRedirect";
import UserGreeting from "../../components/UserGreeting/UserGreeting";
import OfflinePage from "../OfflinePage/OfflinePage";
const Card = styled(MuiCard)(spacing);

const ProfileWrapperSwitch = [
  {
    label: "Personal Details",
    value: 1,
  },
  {
    label: "Performance",
    value: 2,
  },
];

function Private({ auth, isOnline }) {
  const [currentRole, setCurrentRole] = useState(null);
  const [changeMobModalShow, setChangeMobModalShow] = useState(false);
  const [currTab, setCurrTab] = useState(ProfileWrapperSwitch[0]?.value);

  let { AuthData } = auth;

  useEffect(() => {
    const user = AuthData?.userDTO ? roleRedirect(AuthData?.userDTO) : null;
    if (user === "/markorder") {
      setCurrentRole("CHECKER");
    } else if (user === "/picker") {
      setCurrentRole("PICKER");
    } else if (user === "/packer") {
      setCurrentRole("PACKER");
    } else if (user === "/dispatch") {
      setCurrentRole("DISPATCH");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!isOnline) {
    return <OfflinePage />;
  }

  return (
    <Card mb={6} style={{ padding: "1em" }}>
      <ProfileWrapper>
        <UserGreeting />
        <p>{currentRole}</p>
        <br />

        <ProfileTabWrapper
          options={ProfileWrapperSwitch}
          block
          value={currTab}
          onChange={(e) => setCurrTab(e)}
        />

        {currTab === ProfileWrapperSwitch[0]?.value ? (
          <PersonalInfoWrapper>
            <div>
              <label>Email</label>
              <p>{AuthData?.userDTO?.emailAddress}</p>
            </div>

            <div>
              <label>EMP ID</label>
              <p>{AuthData?.userDTO?.userId}</p>
            </div>

            <div>
              <label>Contact</label>
              <div className="mobEditRow">
                <p>{AuthData?.userDTO?.mobileNo}</p>
                <AntButton
                  type="text"
                  onClick={() => setChangeMobModalShow(true)}
                >
                  <FaEdit />
                </AntButton>
              </div>
            </div>

            <div>
              <label>Office Add.</label>
              <p>N/A</p>
            </div>
          </PersonalInfoWrapper>
        ) : (
          <PerformanceTabWrapper>
            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
          </PerformanceTabWrapper>
        )}

        <Modal
          title="Change Mobile Number"
          open={changeMobModalShow}
          onOk={changeMobModalShow}
          centered
          onCancel={() => setChangeMobModalShow(false)}
        >
          <Result title="Upcoming feature!" />
        </Modal>
      </ProfileWrapper>
    </Card>
  );
}

function Settings({ auth, isOnline }) {
  return (
    <React.Fragment>
      <Helmet titleTemplate="Profile" defaultTitle="Checker" />

      <Grid container spacing={6}>
        <Grid item xs={12}>
          <Private auth={auth} isOnline={isOnline} />
        </Grid>
      </Grid>
    </React.Fragment>
  );
}

const mapStateToProps = (state) => ({
  auth: state.authReducer,
  isOnline: state.statusReducer.isOnline,
});

export default connect(mapStateToProps)(Settings);
